/* src/app/feature-modules/forms/form-details/form-details.component.css */
.info-container {
  padding: 20px 29px 0px 30px;
  border-radius: 4px;
  background-color: #ffffff;
  height: 100%;
  min-height: 423px;
  border: solid 0.5px #babbc7;
}
.img {
  vertical-align: middle;
}
.info {
  background-color: #2196F3;
}
.info:hover {
  background: #0b7dda;
}
/*# sourceMappingURL=form-details.component.css.map */
